export const MERCHANT_PORTAL_API_TOKEN = '62OlrqQoaKUZkrgJ6IZqn0QAGBpP7NItSkoZ0YB7Fz4'

export const MERCHANT_PORTAL_API_TOKEN_PREVIEW = '_oiGfYBRtYWSzC_JERZVluao5J24htw6TKaPylL_JEs'

export const MERCHANT_PORTAL_SPACE_ID = 'hynnffk3balp'

export const NAME = 'cms'

export const SET_CMS_ENVIRONMENT = 'SET_CMS_ENVIRONMENT'

export const CMS_ENVIRONMENT_SESSION_STORAGE_KEY = 'mage-cms.cms-environment'
